module.exports = __webpack_public_path__ + "static/oecWelfare.361d24fd.png";